import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Loader } from "react-loaders";
import EventEmitter from "../../../services/event-emitter";
import NumberFormat from "react-number-format";
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest
} from "../../../api/ApiService";
import AbbreviateNumber from "../../../components/ui-building-blocks/numbers/AbbreviateNumber";
import SuccessAlert from "../../alerts/success";
import Fragment from 'react-dot-fragment';
import ErrorAlert from '../../alerts/error';
import WarningAlert from '../../alerts/warning';

const AVAILABLE_CASH = `${process.env.REACT_APP_API_URL}team/page/financials/`;
const OUTSTANDING_CASH = `${process.env.REACT_APP_API_URL}team/post_money/`;
const REPURCHASED_COSTS = `${process.env.REACT_APP_API_URL}team/stock_repurchased/`;
const DIVIDENTS_PAYMENT = `${process.env.REACT_APP_API_URL}team/dividends_payment/`;
const REPURCHASED_COSTS_PERFORMANCE = `${process.env.REACT_APP_API_URL}team/performance_money/`;


class ReturnEquityModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      loading: true,
      availableCash: 0,
      outstandingShares: 0,
      pricePerShares: 0,
      sharesToRepurchase: 0,
      sharesToRepurchaseId: 0,
      dividentPayment: 0,
      dividentPaymentId: 0,
      error: "",
      showError: false,
      errorTitle: '',
      errorMessage: '',
      showAlert: '',
      successMessage: null,
      onAlertSuccess: () => { }
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  get totalRepurchaseCosts() {
    const { pricePerShares, sharesToRepurchase } = this.state;

    return pricePerShares * sharesToRepurchase;
  }

  fetchData = () => {
    const { roundNumber } = this.props;
    const prevRoundNumber = roundNumber - 1 > 0 ? roundNumber - 1 : 1;

    this.setState({
      loading: true
    });

    getRequest(REPURCHASED_COSTS + `?round_number=${roundNumber}`).then(res => {
      this.setState({
        id: res.body.length > 0 ? res.body[0].id : 0,
      });
    });

    getRequest(AVAILABLE_CASH + `?round_number=${roundNumber}`).then(res => {
      const { ending_cash } = res.body.team;

      this.setState({
        availableCash: Number(ending_cash.toFixed(0)),
        loading: false
      });
    });

    getRequest(OUTSTANDING_CASH + `?round_number=${roundNumber}`).then(res => {
      if (res.body.length > 0) {
        const { shares } = res.body[0];

        this.setState({
          outstandingShares: shares
        });
      }
    });

    getRequest(
      REPURCHASED_COSTS_PERFORMANCE + `?round_number=${prevRoundNumber}`
    ).then(res => {
      if (res.body.length > 0) {
        const { share_price } = res.body[0];

        this.setState({
          pricePerShares: Number(share_price.toFixed(2))
        });
      }
    });

    getRequest(REPURCHASED_COSTS + `?round_number=${roundNumber}`).then(res => {
      if (res.body.length > 0) {
        const { shares, id } = res.body[0];

        this.setState({
          sharesToRepurchase: shares,
          sharesToRepurchaseId: id
        });
      } else {
        this.setState({
          sharesToRepurchase: 0,
          sharesToRepurchaseId: 0
        });
      }
    });

    getRequest(DIVIDENTS_PAYMENT + `?round_number=${roundNumber}`).then(res => {
      if (res.body.length > 0) {
        const { payment, id } = res.body[0];

        this.setState({
          dividentPayment: payment,
          dividentPaymentId: id
        });
      } else {
        this.setState({
          dividentPayment: 0,
          dividentPaymentId: 0
        });
      }
    });
  };

  deleteDividentPayment = () => {
    const { dividentPaymentId } = this.state;

    if (dividentPaymentId > 0) {
      deleteRequest(DIVIDENTS_PAYMENT + `${dividentPaymentId}/`).then(res => {
        this.hideAlert();
        this.fetchData();
      });
    }
  };

  submitDividentPayment = () => {
    const { reloadData } = this.props;
    const { dividentPayment, dividentPaymentId } = this.state;

    this.setState({
      error: ""
    });

    const sendRequest = dividentPaymentId > 0 ? putRequest : postRequest;
    const url = dividentPaymentId > 0 ? `${dividentPaymentId}/` : "";

    sendRequest(DIVIDENTS_PAYMENT + url)
      .send({ payment: dividentPayment })
      .then(res => {
        this.showSuccessMessage((
          <Fragment>
            A dividend payment of <b>{(dividentPayment).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            })}</b> is successfully scheduled to be paid to equity investors
          </Fragment>
        ));
        reloadData();
        this.fetchData();
      })
      .catch(err => {
        if (err.response) {
          if ("payment" in err.response.body) {
            this.handleError(err.response.body["payment"][0].toLowerCase());
          } else if ("non_field_errors" in err.response.body) {
            this.handleError(
              err.response.body["non_field_errors"][0].toLowerCase()
            );
          }
        }
      });
  };

  deleteSharesToRepurchase = () => {
    const { sharesToRepurchaseId } = this.state;

    if (sharesToRepurchaseId > 0) {
      deleteRequest(REPURCHASED_COSTS + `${sharesToRepurchaseId}/`).then(
        res => {
          this.hideAlert();
          this.fetchData();
        }
      );
    }
  };

  submitSharesToRepurchase = () => {
    const { reloadData } = this.props;
    const { sharesToRepurchase, sharesToRepurchaseId } = this.state;

    this.setState({
      error: ""
    });

    const sendRequest = sharesToRepurchaseId > 0 ? putRequest : postRequest;
    const url = sharesToRepurchaseId > 0 ? `${sharesToRepurchaseId}/` : "";

    sendRequest(REPURCHASED_COSTS + url)
      .send({ shares: sharesToRepurchase })
      .then(res => {
        const { shares, cost } = res.body;
        this.showSuccessMessage((
          <Fragment>
            <b>{shares.toLocaleString('en-US')}</b> shares is successfully scheduled to be repurchased at a cost <b>{(cost).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            })}</b>
          </Fragment>
        ));
        reloadData();
        this.fetchData();
      })
      .catch(err => {
        if (err.response) {
          if ("shares" in err.response.body) {
            this.handleError(err.response.body["shares"][0].toLowerCase());
          } else if ("non_field_errors" in err.response.body) {
            this.handleError(
              err.response.body["non_field_errors"][0].toLowerCase()
            );
          }
        }
      });
  };

  handleError = text => {
    let errorTitle = '';
    let errorMessage = '';
    if (text.indexOf("shares cannot be negative") > -1) {
      errorTitle = 'Value Cannot Be Negative';
      errorMessage = 'Please input a value that’s zero or greater';
    }
    if (text.indexOf("payment cannot be negative") > -1) {
      errorTitle = 'Value Cannot Be Negative';
      errorMessage = 'Please input a value that’s zero or greater';
    }
    if (text.indexOf("cannot repurchase more than available") > -1) {
      errorTitle = 'Buyback > Outstanding Shares';
      errorMessage = 'You cannot buy back more than your outstanding shares.';
    }
    if (
      text.indexOf("amount too high") > -1 ||
      text.indexOf("amount exceeds the available capital") > -1
    ) {
      errorTitle = 'Value > Available Cash';
      errorMessage = 'Payment cannot exceed your available cash balance';
    }
    if (text.indexOf("exceding debt to capital ratio") > -1) {
      errorTitle = 'Debt to Capital Breach';
      errorMessage = 'This payment would put you in breach of your lender(s) debt-to-capital limit. In order to make this payment, you’ll need to reduce your debt-to-capital ratio.';
    }

    if (text !== "") {
      this.setState({
        showError: true,
        errorTitle,
        errorMessage
      });
    }
  };

  show = () => {
    this.setState(
      {
        show: true
      },
      () => {
        this.fetchData();
      }
    );
  };

  close = () => {
    this.setState({
      show: false
    });

  };

  hideError = () => {
    this.setState({
      showError: false
    });
  };

  showAlert = (onAlertSuccess) => {
    this.setState({
      showAlert: true,
      onAlertSuccess
    });
  };

  hideAlert = () => {
    this.setState({
      showAlert: false
    });
  };

  onModifyRepCosts = () => {
    const urlForPut = REPURCHASED_COSTS + `${this.state.id}`;
    this.handlingErrors(" ");

    console.log(urlForPut);

    if (this.state.id !== "") {
      putRequest(urlForPut)
        .send({
          shares: this.state.repurchasedCosts.replace(/,/g, "")
        })
        .then(res => {
          this.handlingErrors(" ");
          this.setState({
            id: ""
          });
          this.fetchData();
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  modifyDivident = () => {
    const urlForPut = DIVIDENTS_PAYMENT + `${this.state.dividentPaymentId}`;
    this.handlingErrors(" ");

    console.log(urlForPut);
    if (this.state.dividentPaymentId !== "") {
      putRequest(urlForPut)
        .send({
          payment: this.state.dividentPayment.replace("$", "").replace(/,/g, "")
        })
        .then(res => {
          this.handlingErrors(" ");
          this.setState({
            dividentPaymentId: ""
          });
          this.fetchData();
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleChangeShares = (e, value) => {
    const val =
      "floatValue" in value ? value.floatValue : Number(e.target.value);
    this.setState({
      sharesToRepurchase: val
    });
  };

  handleChangeDivident = (e, value) => {
    const val =
      "floatValue" in value ? value.floatValue : Number(e.target.value);
    this.setState({
      dividentPayment: val
    });
  };

  componentDidMount() {
    this.eventemitter.on("show-return-equity-modal", this.show);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-return-equity-modal", this.show);
  }

  conditionalRenderCash() {
    const { availableCash } = this.state;

    return (
      <span style={{ color: availableCash < 0 ? "#FF4D4F" : "#9EA8B4" }}>
        <NumberFormat
          value={availableCash}
          displayType="text"
          prefix="$"
          thousandSeparator=","
        />
      </span>
    );
  }

  render() {
    const {
      show,
      loading,
      outstandingShares,
      pricePerShares,
      sharesToRepurchase,
      sharesToRepurchaseId,
      dividentPayment,
      showError,
      errorTitle,
      errorMessage,
      successMessage,
      showAlert,
      onAlertSuccess
    } = this.state;

    return (
      <Modal
        show={show}
        onHide={this.close}
        dialogClassName="modal-dialog-bigger-more fn-modal-dialog finance-decisions-modal"
      >
        {showError && (
          <ErrorAlert
            title={errorTitle}
            message={errorMessage}
            onHide={this.hideError}
          />
        )}
        {showAlert && (
          <WarningAlert
            title="Are you sure?"
            message="Deleting this decision cannot be undone"
            onSuccess={onAlertSuccess}
            onCancel={this.hideAlert}
          />
        )}
        <Modal.Header closeButton={true}>
          <h3>Returning Capital | Equity</h3>
          <p>Cash Balance: {this.conditionalRenderCash()}</p>
        </Modal.Header>
        <Modal.Body>
          {loading === true && (
            <div className="text-center loader-inline">
              <Loader type="ball-scale-ripple" active />
            </div>
          )}
          {loading === false && (
            <div>
              {successMessage && <SuccessAlert
                message={successMessage}
                marginTop={1}
                marginBottom={80}
              />}
              <div className="modal-narrow-wrapper">
                <div className="modal-line outstanding-line">
                  <p className="modal-label">Outstanding Shares</p>
                  <p className="modal-value">
                    <NumberFormat
                      value={outstandingShares}
                      displayType="text"
                      thousandSeparator=","
                    />
                  </p>
                </div>
                <div className="modal-line buyback-line">
                  <p className="modal-label black">Buyback Shares</p>
                  <p className="modal-input-wrapper">
                    <AbbreviateNumber
                      type="input"
                      value={sharesToRepurchase}
                      onChange={this.handleChangeShares}
                      prefix={""}
                    />
                  </p>
                </div>
                <div className="modal-line per-share-line">
                  <p className="modal-label">Price Per Share</p>
                  <p className="modal-value">
                    <NumberFormat
                      value={pricePerShares}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                    />
                  </p>
                </div>
                <div className="modal-divider"></div>
                <div className="modal-line repurchase-cost-line">
                  <p className="modal-label">Total Repurchase Cost</p>
                  <div className="modal-right-content-container">
                    <p className="modal-value">
                      <NumberFormat
                        value={this.totalRepurchaseCosts}
                        displayType="text"
                        prefix="$"
                        thousandSeparator=","
                      />
                    </p>
                    <div>
                      <button
                        type="button"
                        className="modal-button"
                        onClick={this.submitSharesToRepurchase}
                      >
                        Update
                      </button>
                      {sharesToRepurchaseId > 0 && (
                        <button
                          type="button"
                          className="modal-button delete"
                          onClick={() => this.showAlert(this.deleteSharesToRepurchase)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-divider"></div>
              <div className="modal-narrow-wrapper">
                <div className="modal-line pay-dividends-line">
                  <p className="modal-label black">Pay Dividends</p>
                  <div className="modal-right-content-container">
                    <p className="modal-input-wrapper">
                      <AbbreviateNumber
                        type="input"
                        value={dividentPayment}
                        onChange={this.handleChangeDivident}
                      />
                    </p>
                    <div>
                      <button
                        type="button"
                        className="modal-button"
                        onClick={this.submitDividentPayment}
                      >
                        Update
                      </button>
                      {sharesToRepurchaseId > 0 && (
                        <button
                          type="button"
                          className="modal-button delete"
                          onClick={() => this.showAlert(this.deleteDividentPayment)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default ReturnEquityModal;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/return-equity-modal.js